import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
import pdfWorkerSrc from 'file-loader?name=js/[name].[contenthash:8].[ext]!pdfjs-dist/legacy/build/pdf.worker.min.js'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerSrc

export default pdfjsLib
